namespace RioERP.Masters {
    export namespace EmailTemplateVariablesService {
        export const baseUrl = 'Masters/EmailTemplateVariables';

        export declare function Create(request: Serenity.SaveRequest<EmailTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<EmailTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<EmailTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<EmailTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/EmailTemplateVariables/Create",
            Update = "Masters/EmailTemplateVariables/Update",
            Delete = "Masters/EmailTemplateVariables/Delete",
            Retrieve = "Masters/EmailTemplateVariables/Retrieve",
            List = "Masters/EmailTemplateVariables/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>EmailTemplateVariablesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
